/**
 * @file frontend/src/lib/sw_register.js
 * @description Register the service worker (WP-1.1 PWA scaffolding).
 *
 * Called once from index.js. Tolerates HTTPS-only constraint (SW won't
 * register on http://localhost in some browsers — that's expected).
 */
import { flushQueue } from './offline_queue';
import { flushPunchQueue } from './offlinePunchQueue';
import { api } from './api';

let registration = null;

export function registerServiceWorker() {
  if (typeof navigator === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  // Only register on HTTPS or localhost.
  const isLocalhost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  const isHttps = window.location.protocol === 'https:';
  if (!isHttps && !isLocalhost) return;

  window.addEventListener('load', async () => {
    try {
      // Append the build commit as a query param so the browser re-fetches
      // sw.js on every deploy, picking up the new CACHE_VERSION inside it.
      const swVersion = process.env.REACT_APP_GIT_COMMIT || 'local';
      registration = await navigator.serviceWorker.register(`/sw.js?v=${swVersion}`, { scope: '/' });
      console.log('[K12 ERP] Service worker registered:', registration.scope);

      navigator.serviceWorker.addEventListener('message', async (event) => {
        if (event.data?.type === 'replay-pending-logs') {
          // Background sync fired — flush the queue.
          try { await flushQueue(api); } catch (e) { /* ignore */ }
        }
        if (event.data?.type === 'replay-pending-punches') {
          // Photos stay on the device until the page knows the photo flag is on.
          try { await flushPunchQueue(api, { punchPhotoOn: false }); } catch (e) { /* ignore */ }
        }
      });
    } catch (err) {
      console.warn('[K12 ERP] Service worker registration failed:', err);
    }
  });

  // Best-effort flush whenever we come back online.
  window.addEventListener('online', () => {
    flushQueue(api).catch(() => {});
    flushPunchQueue(api, { punchPhotoOn: false }).catch(() => {});
  });
}

export function getRegistration() {
  return registration;
}
